import { createAction } from '@reduxjs/toolkit';

export const REMOVE_USER_BY_PHONE = 'REMOVE_USER_BY_PHONE';

export const removeUserByPhone = createAction(
    REMOVE_USER_BY_PHONE,
    () => ({ payload: [] }),
);
